/** Inclusive calendar-day count between YYYY-MM-DD dates. */
export function inclusiveDayCount(
  dateFrom: string,
  dateTo: string,
): number | null {
  const a = Date.parse(`${dateFrom.slice(0, 10)}T00:00:00Z`);
  const b = Date.parse(`${dateTo.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(a) || Number.isNaN(b) || b < a) return null;
  return Math.round((b - a) / 86_400_000) + 1;
}

/** e.g. `2026-09-02 — 2026-09-13 (12)` or `2026-09-02 — Unknown`. */
export function formatJourneyDateRange(
  dateFrom: string | null | undefined,
  dateTo: string | null | undefined,
  unknownLabel: string,
): string {
  const from = (dateFrom || '').trim();
  const to = (dateTo || '').trim();
  if (!from && !to) return '';
  if (from && !to) return `${from} — ${unknownLabel}`;
  if (!from && to) return to;
  if (from === to) return from;
  const days = inclusiveDayCount(from, to);
  const suffix = days != null ? ` (${days})` : '';
  return `${from} — ${to}${suffix}`;
}
